export const PRO_GROWTH_LOANS_TAB = 'provider_growth_loans_tab_enabled_ev4736_20240611';
